import { combineEpics } from 'redux-observable';
import HelloEpic from './helloEpic'
import IndexEpic from './indexEpic'

export default combineEpics(...Object.values(HelloEpic.Epics), ...Object.values(IndexEpic.Epics))
